import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this._isVisible}}\n  {{yield this.dismissAlert}}\n{{/if}}",{ moduleName: "cio/components/persist-dismissal/index.hbs" })